import PropTypes from 'prop-types';
/* eslint new-cap: ["error", { "capIsNewExceptions": ["HOC"] }] */
import React from 'react';
import { Grid } from 'semantic-ui-react';
import styles from './CardField.scss';

export default class CardFieldNoValidate extends React.Component {
  static propTypes = {
    children: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    id: PropTypes.string,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    setValue: PropTypes.func,
    getValue: PropTypes.func,
    onChange: PropTypes.func,
    showError: PropTypes.func,
    hasValue: PropTypes.func,
    validationError: PropTypes.string,
    required: PropTypes.bool,
    submitted: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      focused: false,
      initialBlur: false,
      id: this.getId()
    };
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.changeValue = this.changeValue.bind(this);
  }

  componentWillUnmount() {
    if (document && document.activeElement) {
      document.activeElement.blur();
    }
  }

  onFocus(e) {
    this.setState({ focused: true });
    if (this.props.onFocus) this.props.onFocus(e);
  }

  onBlur(e) {
    // Make exception for blurring field to access DayPicker
    if (
      !(e.relatedTarget && e.relatedTarget.className.match('DayPicker-Day'))
    ) {
      this.setState({ focused: false, initialBlur: true });
      if (this.props.onBlur) this.props.onBlur(e);
    }
  }

  getId() {
    return (
      this.props.id ||
      `${Math.random().toString(36)}00000000000000000`.slice(2, 16 + 2)
    );
  }

  changeValue(e) {
    this.props.setValue(e.target.value);
    this.props.onChange(e);
  }

  render() {
    // Workaround to validate required fields that are empty
    const { showError, hasValue, validationError } = this.props;
    const hasError =
      (this.state.initialBlur || this.props.submitted) &&
      (showError() || (this.props.required && !hasValue()));
    const errorMessage = hasError ? validationError : null;
    const inputWidth = this.props.label ? 12 : 16;

    return (
      <Grid
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        className={[
          this.state.focused ? styles.focused : '',
          this.props.className,
          errorMessage ? styles.error : ''
        ].join(' ')}
      >
        <Grid.Row className={styles.row}>
          {this.props.label &&
            <Grid.Column width={4} textAlign='right' className={styles.row}>
              <label htmlFor={this.state.id}>{this.props.label}:</label>
            </Grid.Column>}
          <Grid.Column width={inputWidth} className={styles.row}>
            {React.cloneElement(this.props.children, {
              id: this.state.id,
              onChange: this.changeValue,
              value: this.props.getValue()
            })}
            <div className={styles.errorMessage}>
              {errorMessage}
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Elements/CardField/CardFieldNoValidate.js